import React from "react";
import { Container, Typography, Button, Paper, Box } from "@mui/material";
import { Link } from "react-router-dom";
import logo from "./logoCC.png";
import logoSm from "./logo.png";

const App = () => {
  return (
    <Container
      maxWidth="sm"
      sx={{
        minHeight: "100vh",
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
        fontFamily: "'Inter', sans-serif",
      }}
    >
      <Paper
        elevation={3}
        sx={{
          p: 2,
          textAlign: "center",
          width: "100%",
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          gap: 2,
          fontFamily: "'Inter', sans-serif",
        }}
      >
        <img src={logoSm} alt="Logo" width={100} />
        <Typography variant="h5" align="center" sx={{ fontWeight: 600, fontSize: "18px", mb: 2 }}>
          Bienvenido Admin
        </Typography>

        <Box sx={{ width: "100%", display: "flex", flexDirection: "column", gap: 2 }}>
          <Button
            variant="contained"
            component={Link}
            to="/forms/sendForm "
            fullWidth
            sx={{
              backgroundColor: "#00b3ce",
              color: "#FFF",
              fontWeight: 500,
              fontSize: "15px",
              paddingY: "10px"
            }}
          >
            Enviar formulario
          </Button>
          <Button
            variant="contained"
            component={Link}
            to="/forms/steps"
            fullWidth
            sx={{
              backgroundColor: "#ffaa00",
              color: "#FFF",
              fontWeight: 500,
              fontSize: "15px",
              paddingY: "10px"
            }}
          >
            Rellenar formulario
          </Button>
          <Button
            variant="contained"
            component={Link}
            to="/forms/formsHistory"
            fullWidth
            sx={{
              backgroundColor: "#fff",
              color: "#00b3ce",
              border: "1px solid #00b3ce",
              fontWeight: 500,
              fontSize: "15px",
              paddingY: "10px"
            }}
          >
            Ver historial
          </Button>
        </Box>
      </Paper>
      <div style={{textAlign: "center", marginTop: "10px"}}>
        <img src={logo} alt="Logo CodeCanario" width={120}/>
      </div>
    </Container>
  );
};

export default App;
